export const AGY_CLI_VERSION = '1.4.6';
